var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-select',{attrs:{"options":_vm.discountActivationsOpt,"size":"sm"},model:{value:(_vm.provinceProduct.discount_rules_id),callback:function ($$v) {_vm.$set(_vm.provinceProduct, "discount_rules_id", $$v)},expression:"provinceProduct.discount_rules_id"}})
}
var staticRenderFns = []

export { render, staticRenderFns }